module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "properties-matching"
    }
  }, [_c('div', {
    staticClass: "row no-padding-bottom"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "component-name"
  }, [_vm._v(_vm._s(_vm.$t('integrations.title.properties_matching')))]), _c('a', {
    staticClass: "collapse-button",
    class: {
      'bloqued': _vm.api_fields.length == 0
    },
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#multiCollapse1",
      "aria-expanded": "false",
      "aria-controls": "multiCollapse1"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.actions.view.properties_matching'))), _c('span', {
    staticClass: "gray-bold-caret"
  })]), _c('hr')])]), _c('div', {
    staticClass: "collapse multi-collapse",
    attrs: {
      "id": "multiCollapse1"
    }
  }, [_c('div', [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.properties_matching.dragOrCreate')))]), _c('br'), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.properties_matching.fieldsFilled')))])]), _c('div', {
    staticClass: "row"
  }), (_vm.matching_deal.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.contactProperties')))])])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _c('draggable', {
    attrs: {
      "value": _vm.matching,
      "options": _vm.draggable_options,
      "move": _vm.onMove,
      "tag": "ul"
    },
    on: {
      "input": _vm.matchingUpdated,
      "change": _vm.matchingChanged
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "matching"
    }
  }, _vm._l((_vm.matching_person), function(field, idx) {
    return _c('div', {
      key: field.integration,
      staticClass: "form-group item"
    }, [(field.reev) ? _c('div', {
      staticClass: "box-matching"
    }, [_c('input', {
      staticClass: "form-control draggable removable",
      class: field.type,
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": field.reev_name
      }
    }), _c('span', {
      staticClass: "remove-icon",
      on: {
        "click": function($event) {
          return _vm.removeField(field, idx)
        }
      }
    }, [_vm._v("x")])]) : _c('div', {
      staticClass: "box-no"
    }, [_c('v-autocomplete', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.onClickaway),
        expression: "onClickaway"
      }],
      staticClass: "box-no-matching no-border",
      attrs: {
        "items": _vm.reev_fields,
        "get-label": _vm.getLabel,
        "component-item": _vm.template,
        "input-attrs": _vm.attrs,
        "auto-select-one-item": false,
        "min-len": 0
      },
      on: {
        "update-items": _vm.updateAutocomplete,
        "input": _vm.updateProperty
      },
      model: {
        value: (_vm.filter[field.integration]),
        callback: function($$v) {
          _vm.$set(_vm.filter, field.integration, $$v)
        },
        expression: "filter[field.integration]"
      }
    }), (!_vm.current_user.isSeller()) ? _c('span', {
      staticClass: "icon",
      on: {
        "click": _vm.openModal
      }
    }, [_vm._v("+")]) : _vm._e()], 1)])
  }), 0)], 1)], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), _vm._l((_vm.api_fields_person), function(field) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      staticClass: "form-control",
      class: _vm.api_field_class(field),
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": field.name
      }
    })])
  })], 2)]), (_vm.matching_deal.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.businessProperties')))])])])]) : _vm._e(), (_vm.matching_deal.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _c('draggable', {
    attrs: {
      "value": _vm.matching,
      "options": _vm.draggable_options,
      "move": _vm.onMove,
      "tag": "ul"
    },
    on: {
      "input": _vm.matchingUpdated,
      "change": _vm.matchingChanged
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "matching"
    }
  }, _vm._l((_vm.matching_deal), function(field, idx) {
    return _c('div', {
      key: field.origin + "-" + field.integration,
      staticClass: "form-group item"
    }, [(field.reev) ? _c('div', {
      staticClass: "box-matching"
    }, [_c('input', {
      staticClass: "form-control draggable removable",
      class: field.type,
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": field.reev_name
      }
    }), _c('span', {
      staticClass: "remove-icon",
      on: {
        "click": function($event) {
          return _vm.removeField(field, idx)
        }
      }
    }, [_vm._v("x")])]) : _c('div', {
      staticClass: "box-no"
    }, [_c('v-autocomplete', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.onClickaway),
        expression: "onClickaway"
      }],
      staticClass: "box-no-matching no-border",
      attrs: {
        "items": _vm.reev_fields,
        "get-label": _vm.getLabel,
        "component-item": _vm.template,
        "input-attrs": _vm.attrs,
        "auto-select-one-item": false,
        "min-len": 0
      },
      on: {
        "update-items": _vm.updateAutocomplete,
        "input": _vm.updateProperty
      },
      model: {
        value: (_vm.filter[field.integration]),
        callback: function($$v) {
          _vm.$set(_vm.filter, field.integration, $$v)
        },
        expression: "filter[field.integration]"
      }
    }), (!_vm.current_user.isSeller()) ? _c('span', {
      staticClass: "icon",
      on: {
        "click": _vm.openModal
      }
    }, [_vm._v("+")]) : _vm._e()], 1)])
  }), 0)], 1)], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), _vm._l((_vm.api_fields_deal), function(field) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      staticClass: "form-control",
      class: _vm.api_field_class(field),
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": field.name
      }
    })])
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.notMatchedProperties')))])]), _c('draggable', {
    attrs: {
      "value": _vm.reev_fields,
      "options": _vm.draggable_options,
      "move": _vm.onMove,
      "tag": "ul"
    },
    on: {
      "input": _vm.reevFieldsUpdated
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "reev_fields"
    }
  }, _vm._l((_vm.reev_fields), function(field) {
    return (!field.matching) ? _c('div', {
      key: field.key,
      staticClass: "form-group item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      staticClass: "form-control draggable",
      class: field.type,
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": field.name
      },
      domProps: {
        "value": (field.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "value", $event.target.value)
        }
      }
    })]) : _vm._e()
  }), 0)], 1)], 1)])]), _c('new-custom-fields-modal', {
    attrs: {
      "edit_custom_field": _vm.edit_custom_field
    },
    on: {
      "close-create-modal": _vm.closeCreateModal,
      "custom-field-created": _vm.custom_field_created
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v("Reev")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v("Reev")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6232921e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/properties_matching.vue
// module id = 1148
// module chunks = 1